import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const CloseSquare: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      d="M17.8534 15.9983L24.9067 8.94493C25.4267 8.42493 25.4267 7.58505 24.9067 7.06505C24.3867 6.54505 23.5467 6.54505 23.0267 7.06505L15.9734 14.1183L8.92002 7.06505C8.40002 6.54505 7.56002 6.54505 7.04002 7.06505C6.52002 7.58505 6.52002 8.42493 7.04002 8.94493L14.0934 15.9983L7.04002 23.0518C6.52002 23.5718 6.52002 24.4116 7.04002 24.9316C7.30669 25.1983 7.64002 25.3183 7.98669 25.3183C8.33336 25.3183 8.66669 25.185 8.93336 24.9316L15.9867 17.8784L23.0401 24.9316C23.3067 25.1983 23.6401 25.3183 23.9867 25.3183C24.3334 25.3183 24.6667 25.185 24.9334 24.9316C25.4534 24.4116 25.4534 23.5718 24.9334 23.0518L17.8801 15.9983H17.8534Z"
      fill="currentColor"
    />
  </Icon>
);
